import PropTypes from 'prop-types';
import React from 'react';

import './BigNumbers.css';


function BigNumbers({ numbers }) {
  const numberComponents = numbers.map(n => (
    <div key={n.slug} className="BigNumber_Container">
      <div className="BigNumber">{n.value}</div>
      <div className="BigNumber_Description">{n.label}</div>
    </div>
  ));

  return (
    <div className="BigNumbers">
      {numberComponents}
    </div>
  );
}


BigNumbers.propTypes = {
  numbers: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ).isRequired,
};

export default BigNumbers;
